import React from 'react'
import Pt from 'prop-types'
import cx from 'classnames'

function Icon(props) {
  const {
    Component,
    className,
    name,
    size,
    rotate,
    flip,
    spin,
    fixedWidth,
    stack,
    inverse,
    pulse,
    ...otherProps
  } = props

  const classes = {
    fa: true,
    'fa-fw': fixedWidth,
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-inverse': inverse,
  }
  classes[`fa-${name}`] = true

  if (size) {
    classes[`fa-${size}`] = true
  }
  if (rotate) {
    classes[`fa-rotate-${rotate}`] = true
  }
  if (flip) {
    classes[`fa-flip-${flip}`] = true
  }
  if (stack) {
    classes[`fa-stack-${stack}`] = true
  }

  return (
    <Component {...otherProps} className={cx(className, classes)} />
  )
}

Icon.defaultProps = {
  Component: 'i',
}
Icon.propTypes = {
  name: Pt.string.isRequired,
  className: Pt.string,
  size: Pt.oneOf(['lg', '2x', '3x', '4x', '5x']),
  rotate: Pt.oneOf(['45', '90', '135', '180', '225', '270', '315']),
  flip: Pt.oneOf(['horizontal', 'vertical']),
  fixedWidth: Pt.bool,
  spin: Pt.bool,
  pulse: Pt.bool,
  stack: Pt.oneOf(['1x', '2x']),
  inverse: Pt.bool,
  Component: Pt.oneOfType([Pt.string, Pt.func]),
}

export default Icon



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Icon.jsx